module.exports = __webpack_public_path__ + "catalog/lines/wall/textures/painted-normal.jpg";